import { render, staticRenderFns } from "./tablelist.vue?vue&type=template&id=a228c2fe&scoped=true&"
import script from "./tablelist.vue?vue&type=script&lang=js&"
export * from "./tablelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a228c2fe",
  null
  
)

export default component.exports